export default "__VITE_ASSET__BSUkhrup__"